function apOpenRec(){
  document.getElementById('apRecOverlay').classList.add('open');
  document.getElementById('apRecPanel').classList.add('open');
}
function apCloseRec(){
  document.getElementById('apRecOverlay').classList.remove('open');
  document.getElementById('apRecPanel').classList.remove('open');
}
function apSubmitRec(){
  var name=document.getElementById('apRecName').value.trim();
  var email=document.getElementById('apRecEmail').value.trim();
  var msg=document.getElementById('apRecMsg').value.trim();
  if(!name){document.getElementById('apRecName').style.borderColor='#EF2E27';return;}
  if(!email||email.indexOf('@')===-1){document.getElementById('apRecEmail').style.borderColor='#EF2E27';return;}
  if(!msg){document.getElementById('apRecMsg').style.borderColor='#EF2E27';return;}
  var btn=document.querySelector('.ap-rec-submit');
  btn.textContent='Sending...';btn.disabled=true;
  var formData=new FormData();
  formData.append('name',name);
  formData.append('email',email);
  formData.append('question',msg);
  formData.append('_subject','Recommendation request from '+name);
  fetch('https://formspree.io/f/mvzwdnzp',{method:'POST',body:formData,headers:{'Accept':'application/json'}})
  .then(function(res){
    if(res.ok){document.getElementById('apRecForm').style.display='none';document.getElementById('apRecSuccess').style.display='block';}
    else{btn.textContent='Send My Question';btn.disabled=false;}
  }).catch(function(){btn.textContent='Send My Question';btn.disabled=false;});
}
document.addEventListener('DOMContentLoaded',function(){
  var sections=document.querySelectorAll('.ap-section');
  var navLinks=document.querySelectorAll('.ap-nav-item, .ap-sidebar-link');
  var obs=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){navLinks.forEach(function(l){l.classList.toggle('active',l.getAttribute('href')==='#'+e.target.id);});}
    });
  },{rootMargin:'-25% 0px -65% 0px'});
  sections.forEach(function(s){obs.observe(s);});
  document.querySelectorAll('.ap-nav-item,.ap-sidebar-link').forEach(function(a){
    a.addEventListener('click',function(e){
      var href=a.getAttribute('href');
      if(href&&href.startsWith('#')){var t=document.querySelector(href);if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth',block:'start'});}}
    });
  });
});